import { Component, computed, Inject, inject, PLATFORM_ID } from '@angular/core';
import { HeaderService } from '../header/header.service';
import { SignalsStoreService } from '../signals-store.service';
import { ResolutionService } from '../resolution.service';
import { SearchBarComponent } from '../header/search-bar/search-bar.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { StockService } from '../../stock/stock.service';
import { ProductsService } from '../../product/products.service';
import { SidebarService } from '../sidebar/sidebar.service';
import { LocalStorageService } from '../local-storage.service';
import { LOCALSTORAGE_KEYS } from '../constants/databases';
import { SidebarCheckList } from '../sidebar/sidebar.types';
import { toObservable } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-categories-dropdown',
  imports: [SearchBarComponent, MatFormFieldModule, MatSelectModule],
  templateUrl: './categories-dropdown.component.html',
  styleUrl: './categories-dropdown.component.scss'
})
export class CategoriesDropdownComponent {
  private headerService = inject(HeaderService);
  private signalsStoreService = inject(SignalsStoreService);
  private resolutionService = inject(ResolutionService);
  private stockService = inject(StockService);
  private productsService = inject(ProductsService);
  private sidebarService = inject(SidebarService);
  private localStorageService = inject(LocalStorageService);

  isMobile = computed(() => this.resolutionService.isMobile());
  displaySearchBar = computed(() => this.headerService.displaySearchBar());
  isShowingSearchMobile = computed(() => {
    const dsb = this.displaySearchBar();
    const fbp = this.signalsStoreService.filterByProducer();
    const im = this.isMobile();
    return !!(dsb || fbp) && im;

  });
  isContentLoading = computed(() => this.stockService.isLoading() || this.productsService.isLoading());
  isContentLoaded = computed(() => this.stockService.isLoaded() || this.productsService.isLoaded());
  sidebar = computed(() => this.sidebarService.sidebar());
  selectedCategory = computed(() => this.signalsStoreService.selectedCategory());
  isInShopComponent = computed(() => this.signalsStoreService.getIsInShopComponent());

  subcategorySelected!: number;

  constructor(@Inject(PLATFORM_ID) private platformId: any) {
    this.#categoryInViewPort();
  }

  triggerCategoryInfoFetch(
    category: any,
  ) {
    this.signalsStoreService.selectedCategory.set(category);
    this.localStorageService.set(LOCALSTORAGE_KEYS.SELECTED_CATEGORY, category);

    if (category)
      this.goToSection(category);
  }

  goToSection(item: SidebarCheckList) {
    this.productsService.goToSection(item);
  }

  #categoryInViewPort() {
    toObservable(
      this.signalsStoreService
        .categoryInViewPort
    )
      .subscribe(obs => {
        if (!obs) return;

        const { categoryId, subCategoryId } = obs;

        const index = this.sidebarService
          .sidebar()
          .findIndex(x => x.id === categoryId);

        if (index > -1) {
          const category = this.sidebarService.sidebar().find(c => c.id === categoryId);
          this.signalsStoreService.selectedCategory.set(category);
          this.subcategorySelected = subCategoryId;
        }
      });
  }

  toggleSearchMobile(clearFilters: boolean = false) {
    this.headerService.updateSearchBarDisplay();
    if (clearFilters) this.headerService.clearFilters(true)
  }
}
